import { useState } from "react"
import { CheckCircle } from "lucide-react"
import { useAuthStore } from "@/features/auth/useAuthStore"
import { CredentialsForm } from "@/features/auth/CredentialsForm"

/** Профиль: добровольная смена собственного логина и пароля (владельцу нужен код Authenticator). */
export function ChangeCredentialsCard() {
  const [open, setOpen] = useState(false)
  const [done, setDone] = useState(false)
  return (
    <div className="box overflow-hidden p-5 space-y-3">
      <div>
        <h2 className="text-sm font-semibold text-zinc-200">Логин и пароль для входа</h2>
        <p className="text-xs text-zinc-500 mt-0.5">
          Выберите удобный логин и пароль. Для владельца изменение подтверждается кодом Google Authenticator. После
          сохранения нужно войти заново.
        </p>
      </div>
      {done && (
        <p className="text-sm text-emerald-400 flex items-center gap-1.5">
          <CheckCircle size={14} /> Сохранено. Войдите заново с новыми данными.
        </p>
      )}
      {!open ? (
        <button className="text-sm text-violet-300 hover:text-violet-200" onClick={() => setOpen(true)}>
          Изменить логин и пароль
        </button>
      ) : (
        <CredentialsForm
          submitLabel="Сохранить"
          onDone={() => {
            setDone(true)
            setTimeout(() => useAuthStore.getState().logout(), 800)
          }}
        />
      )}
    </div>
  )
}
